import { render, staticRenderFns } from "./createGroupCompany.vue?vue&type=template&id=1b27afb2&scoped=true"
import script from "./createGroupCompany.vue?vue&type=script&lang=js"
export * from "./createGroupCompany.vue?vue&type=script&lang=js"
import style0 from "./createGroupCompany.vue?vue&type=style&index=0&id=1b27afb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b27afb2",
  null
  
)

export default component.exports